import styled from 'styled-components';
import { FONTS } from '@ertelecom/ui-react/assets/js/constants';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 388px;
  margin-top: 80px;
  margin-bottom: 10px;
  margin-right: 72px;
  @media screen and (min-width: 2176px) {
    width: 25%;
  }
  @media screen and (max-width: 1700px) {
    width: 388px;
  }
  @media screen and (max-width: 1200px) {
    width: 366px;
    margin-right: 42px;
  }
  @media screen and (max-width: 990px) {
    width: 324px;
    margin-right: 28px;
  }
  @media screen and (max-width: 739px) {
    width: 100%;
  }
  @media screen and (max-width: 560px) {
    margin: 20px 0 53px 0;
    width: 100%;
  }
`;

export const Image = styled.img`
    width: 64px;
    height: 64px;
`;

export const Title = styled.div`
    ${FONTS.H3};
    margin-top: 10px;
    @media screen and (max-width: 990px){
        ${FONTS.H4};
    }
    @media screen and (max-width: 560px){
        ${FONTS.H3};
    }
`;

export const Text = styled.div`
    ${FONTS.L};
    margin-top: 16px;
`;
